const CHART_SCRIPTS = Object.freeze([
  {
    id: 'chart-js',
    src: 'https://cdn.jsdelivr.net/npm/chart.js@4.4.0/dist/chart.umd.min.js',
    integrity: 'sha384-e6nUZLBkQ86NJ6TVVKAeSaK8jWa3NhkYWZFomE39AvDbQWeie9PlQqM3pmYW5d1g',
  },
  {
    id: 'chartjs-datalabels',
    src: 'https://cdn.jsdelivr.net/npm/chartjs-plugin-datalabels@2.2.0/dist/chartjs-plugin-datalabels.min.js',
    integrity: 'sha384-y49Zu59jZHJL/PLKgZPv3k2WI9c0Yp3pWB76V8OBVCb0QBKS8l4Ff3YslzHVX76Y',
  },
]);

let chartLibraryPromise = null;

export function getChartScriptSpecs() {
  return CHART_SCRIPTS.map((script) => ({ ...script }));
}

function getCspNonce() {
  if (typeof document === 'undefined') return '';
  return document.querySelector('script[nonce]')?.nonce || '';
}

function loadExternalScript({ id, src, integrity }) {
  if (typeof document === 'undefined') return Promise.reject(new Error('当前环境无法加载图表库'));
  const existing = document.querySelector(`script[data-chart-library="${id}"]`);
  if (existing?.dataset.loaded === 'true') return Promise.resolve();
  if (existing) {
    return new Promise((resolve, reject) => {
      existing.addEventListener('load', resolve, { once: true });
      existing.addEventListener('error', () => reject(new Error(`图表库加载失败: ${id}`)), { once: true });
    });
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.dataset.chartLibrary = id;
    script.src = src;
    script.async = true;
    script.integrity = integrity;
    script.crossOrigin = 'anonymous';
    const nonce = getCspNonce();
    if (nonce) script.nonce = nonce;
    script.addEventListener('load', () => {
      script.dataset.loaded = 'true';
      resolve();
    }, { once: true });
    script.addEventListener('error', () => {
      script.remove();
      reject(new Error(`图表库加载失败: ${id}`));
    }, { once: true });
    (document.head || document.body || document.documentElement).appendChild(script);
  });
}

export function loadChartLibrary() {
  if (globalThis.Chart && globalThis.ChartDataLabels) {
    return Promise.resolve({ Chart: globalThis.Chart, ChartDataLabels: globalThis.ChartDataLabels });
  }
  if (!chartLibraryPromise) {
    chartLibraryPromise = (async () => {
      const [chartScript, dataLabelsScript] = CHART_SCRIPTS;
      if (!globalThis.Chart) await loadExternalScript(chartScript);
      if (!globalThis.ChartDataLabels) await loadExternalScript(dataLabelsScript);
      if (!globalThis.Chart) throw new Error('Chart.js 未正确初始化');
      return { Chart: globalThis.Chart, ChartDataLabels: globalThis.ChartDataLabels };
    })().catch((error) => {
      chartLibraryPromise = null;
      throw error;
    });
  }
  return chartLibraryPromise;
}
